import React, { useState } from "react";
import { agents } from "../data/agents";
import AgentBioModal from "../components/AgentBioModal";

const AgentCard = ({ agent, onBioClick }) => {
  const initials = agent.name.split(" ").map((n) => n[0]).join("").slice(0, 2);
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 flex flex-col">
      <div className="aspect-[4/5] bg-gray-200 flex items-center justify-center text-4xl font-bold text-gray-400">
        {agent.photoUrl ? (
          <img src={agent.photoUrl} alt={agent.name} className="w-full h-full object-cover" />
        ) : (
          <span>{initials}</span>
        )}
      </div>
      <div className="p-4 sm:p-5 flex-1 flex flex-col">
        <h3 className="text-xl font-bold text-gray-900">{agent.name}</h3>
        <p className="text-red-600 font-semibold text-sm sm:text-base mb-3">{agent.title}</p>
        <p className="text-gray-600 text-sm sm:text-base flex-1 mb-4 line-clamp-3">{agent.shortBio}</p>
        <button
          onClick={() => onBioClick(agent)}
          className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700 transition min-h-[44px] touch-manipulation"
        >
          Full Bio
        </button>
      </div>
    </div>
  );
};

const Agents = () => {
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleBioClick = (agent) => {
    setSelectedAgent(agent);
    setIsModalOpen(true);
  };

  const sortedAgents = [...agents].sort((a, b) => (a.order ?? 99) - (b.order ?? 99));

  return (
    <section id="agents" className="w-full min-w-full h-full flex-shrink-0 snap-start flex items-center justify-center bg-gray-100 p-4 sm:p-6 md:p-8 overflow-y-auto">
      <div className="max-w-5xl w-full my-4 sm:my-0">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-2 text-center">Our Agents</h1>
        <p className="text-lg sm:text-xl text-gray-600 mb-6 sm:mb-8 text-center max-w-2xl mx-auto">
          Licensed professionals serving St. Louis and surrounding Missouri counties.
        </p>
        <div className={sortedAgents.length === 1 ? "flex justify-center" : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8"}>
          {sortedAgents.map((agent) => (
            <div key={agent.id} className={sortedAgents.length === 1 ? "w-full max-w-sm" : ""}>
              <AgentCard agent={agent} onBioClick={handleBioClick} />
            </div>
          ))}
        </div>
      </div>
      <AgentBioModal agent={selectedAgent} isOpen={isModalOpen} onClose={() => { setIsModalOpen(false); setSelectedAgent(null); }} />
    </section>
  );
};

export default Agents;
